import { OPEN_MODAL, CLOSE_MODAL } from 'constants/actionTypes';

export default function modals(state = [], action) {
  switch (action.type) {
    case OPEN_MODAL:
      return [...state, action.obj];
    case CLOSE_MODAL:
      return state.filter((item) => item.id !== action.obj.id);
    default:
      return state;
  }
}
